var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pattern-container"}},[(!_vm.pattern)?_c('LoadingSpinner'):_vm._e(),(_vm.pattern)?_c('Board'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }